'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _search = require('./remote/search');

var Search = {
    fetchCategoryResults: _search.SearchRemote.fetchCategoryResults,
    fetchPromotedSearchResults: _search.SearchRemote.fetchPromotedSearchResults,
    fetchSearchFacetsResults: _search.SearchRemote.fetchSearchFacetsResults,
    fetchSearchResults: _search.SearchRemote.fetchSearchResults
};

exports.default = Search;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/api/search.js
// module id = TdMF
// module chunks = 60